import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  isFavorite?: boolean;
  onToggleFavorite?: (id: string) => void;
}

export default function MovieCard({ movie, isFavorite, onToggleFavorite }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-accent-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 伦理影视`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs font-semibold text-accent-300">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-700">
          {movie.type === "movie" ? "电影" : "剧集"}
        </span>
        {onToggleFavorite && (
          <button
            type="button"
            aria-label={isFavorite ? "取消收藏" : "收藏"}
            onClick={(event) => {
              event.preventDefault();
              onToggleFavorite(movie.id);
            }}
            className={`absolute bottom-2 right-2 flex h-8 w-8 items-center justify-center rounded-full border transition-colors ${
              isFavorite
                ? "border-accent-400 bg-accent-500 text-primary-950"
                : "border-background-200/70 bg-background-50/90 text-foreground-600 hover:text-accent-600"
            }`}
          >
            <i className={isFavorite ? "ri-heart-fill text-sm" : "ri-heart-line text-sm"}></i>
          </button>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {movie.title}
        </h3>
        <div className="mt-auto flex items-center gap-2 text-xs text-foreground-600">
          <span>{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{movie.tags.slice(1).join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}